export class PickupPoint {
  id: number;
  name: string;
  groupId: number;
  sequence: number;

  constructor(
    id: number,
    name: string,
    groupId: number,
    sequence: number,
  ) {
    this.id = id;
    this.name = name;
    this.groupId = groupId;
    this.sequence = sequence;
  }

  static createFromAny(object: any): PickupPoint {
    if (object === null || object === undefined) {
      return null;
    }

    return new PickupPoint(
      +object.id,
      object.name,
      object.group_id,
      object.sequence,
    );
  }

}
